<template>
  <div class="management-service-reservation">
    <el-form ref="form" :model="filtersForm" label-width="80px" inline>
      <el-form-item label="患者姓名">
        <el-input v-model="filtersForm.compatName" placeholder="请输入患者姓名"></el-input>
      </el-form-item>
      <el-form-item label="申请日期">
        <el-date-picker
          v-model="daterange"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">筛选</el-button>
      </el-form-item>
    </el-form>
    <el-radio-group v-model="checkedStatus">
      <el-radio-button v-for="state in states" :label="state.label" :key="state.text">{{state.text}}</el-radio-button>
    </el-radio-group>
    <el-table :data="list" v-loading="loading" border>
      <el-table-column prop="createTime" :formatter="formatterCreateTime" label="申请日期"></el-table-column>
      <el-table-column prop="compatName" label="姓名"></el-table-column>
      <el-table-column prop="serveName" label="服务名称"></el-table-column>
      <el-table-column prop="serveWay" :formatter="formatterServeWay" label="服务方式"></el-table-column>
      <el-table-column :formatter="formatterServeUsage" label="服务使用情况"></el-table-column>
      <el-table-column :formatter="formatterServeDate" label="期望服务日期"></el-table-column>
      <el-table-column prop="compatMobile" label="联系电话"></el-table-column>
      <el-table-column :formatter="formatAddress" prop="address" label="服务地址"></el-table-column>
      <el-table-column
        :formatter="formatterAppointTime"
        prop="appointTime"
        label="已安排时间"
        v-if="checkedStatus !== 'WAITAUDIT'"
        key="appointTime"
      ></el-table-column>
      <el-table-column min-width="140" key="commentScore" v-if="checkedStatus === 'COMPLETE'" label="服务评价">
        <template slot-scope="scope">
          <el-rate disabled v-model="scope.row.commentScore"></el-rate>
        </template>
      </el-table-column>
      <el-table-column
        key="commentContent"
        v-if="checkedStatus === 'COMPLETE'"
        prop="commentContent"
        label="评价内容"
      ></el-table-column>
      <el-table-column key="cancelReason" label="取消原因" v-if="checkedStatus === 'CANCEL'">
        <template slot-scope="scope">
          <span :title="scope.row.refuseReason">{{scope.row.refuseReason}}</span>
        </template>
      </el-table-column>
      <el-table-column
        key="refuseReason"
        label="拒绝原因"
        v-if="checkedStatus === 'REFUSE'"
      >
        <template slot-scope="scope">
          <span :title="scope.row.refuseReason">{{scope.row.refuseReason}}</span>
        </template>
      </el-table-column>
      <!-- 服务申请 -->
      <el-table-column
        key="WAITAUDIT"
        width="180px"
        align="center"
        label="操作"
        v-if="checkedStatus === 'WAITAUDIT'"
      >
        <template slot-scope="scope">
          <el-button @click.prevent="openRefuseDialog(scope.row)" type="danger" size="small">拒绝</el-button>
          <el-button @click.prevent="openAgreeDialog(scope.row)" type="primary" size="small">同意</el-button>
        </template>
      </el-table-column>
      <!-- 待服务 -->
      <el-table-column
        key="WAITUSE"
        width="200px"
        align="center"
        label="操作"
        v-if="checkedStatus === 'WAITUSE'"
      >
        <template slot-scope="scope">
          <el-button @click.prevent="openCancelDialog(scope.row)" type="danger" size="small">取消预约</el-button>
          <el-button @click.prevent="openServedDialog(scope.row)" type="primary" size="small">已服务</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="pagination-wrapper" type="flex" justify="end">
      <el-pagination
        layout="prev, pager, next"
        :current-page.sync="page.pageNum"
        :total="page.total"
        @current-change="onCurrentChange"
      ></el-pagination>
    </el-row>
    <el-dialog
      :title="`请输入${refuseAndCancelDialogTitle}原因`"
      :visible.sync="refuseAndCancelDialogVisible"
      width="30%"
    >
      <el-input type="textarea" :rows="5" placeholder="拒绝原因" v-model="statementData.reason"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="refuseAndCancelDialogVisible = false">关 闭</el-button>
        <el-button type="primary" @click="onFormSubmit">提 交</el-button>
      </span>
    </el-dialog>
    <el-dialog
      custom-class="agree-dialog"
      :title="`${statementData.title}同意申请`"
      :visible.sync="agreeDialogVisible"
      width="30%"
    >
      <el-row>
        您即将同意
        <span class="red-color">{{statementData.compatName}}</span>的
        <span class="red-color">{{statementData.serveName}}服务</span>，期望服务时间为
        <span class="red-color">{{formatterServeDate(row)}}</span>。
      </el-row>
      <el-row>选择实际{{statementData.desc}}</el-row>
      <el-date-picker
        :picker-options="pickerOptions"
        value-format="yyyy-MM-dd HH:mm"
        v-model="statementData.appointTime"
        type="datetime"
        placeholder="选择日期时间"
      ></el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button @click="agreeDialogVisible = false">关 闭</el-button>
        <el-button type="primary" @click="onAgree">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 确认已服务 -->
    <el-dialog
      custom-class="served-dialog"
      title="服务确认"
      :visible.sync="servedDialogVisible"
      width="30%"
    >
      <el-row type="flex" justify="center">
        <img src="../../../assets/icon/ok.png" alt>
      </el-row>
      <el-row class="served-dialog__desc">确认标记此服务为以服务吗？</el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="servedDialogVisible = false">等一会</el-button>
        <el-button type="primary" @click="onServed">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axiosUtil from "../../utils/AxiosUtils.js";
import { timeFormat, sex } from "ty-vue-filters";
const PAGE = {
  pageNum: 1,
  pageSize: 10,
  pages: 1,
  total: 0
};
const STATES = [
  {
    label: "WAITAUDIT",
    text: "服务申请"
  },
  {
    label: "WAITUSE",
    text: "待服务"
  },
  {
    label: "COMPLETE",
    text: "已服务"
  },
  {
    label: "CANCEL",
    text: "已取消"
  },
  {
    label: "REFUSE",
    text: "已拒绝"
  }
];
class StatementData {
  constructor(row, status) {
    this.serveAppointId = row.id;
    this.appointTime = row.appointTime;
    this.mappointTime = row.mappointTime;
    this.reason = row.reason;
    this.status = row.status;
    this.serveName = row.serveName;
    this.compatName = row.compatName;
    this.serveWay = row.serveWay;
    this.status = status;
  }
  get message() {
    const msgObj = {
      WAITUSE: "同意申请",
      COMPLETE: "完成预约",
      REFUSE: "拒绝申请",
      CANCEL: "取消预约"
    };
    return msgObj[this.status];
  }
  get title() {
    const serveWayObj = {
      ONLINE: "在线",
      DOOR: "上门服务",
      HOSPITAL: "到院服务"
    };
    return serveWayObj[this.serveWay];
  }
  get desc() {
    const descObj = {
      DOOR: "上门服务时间",
      HOSPITAL: "安排服务时间"
    };
    return descObj[this.serveWay];
  }
}
export default {
  data() {
    return {
      daterange: [],
      statementData: Object.create(null),
      row: Object.create(null),
      pickerOptions: {
        disabledDate: date => +date <= Date.now() - 24 * 3600 * 1000
      },
      filtersForm: {
        compatName: "",
        startDate: "",
        endDate: ""
      },
      list: [],
      states: STATES,
      loading: false,
      refuseAndCancelDialogVisible: false,
      agreeDialogVisible: false,
      servedDialogVisible: false,
      page: PAGE,
      checkedStatus: "WAITAUDIT"
    };
  },
  watch: {
    daterange(val) {
      this.filtersForm.startDate = val ? val[0] : "";
      this.filtersForm.endDate = val ? val[1] : "";
    },
    checkedStatus: {
      handler() {
        this.pages = PAGE;
        this.getList();
      },
      immediate: true
    }
  },
  computed: {
    refuseAndCancelDialogTitle() {
      const statusObj = {
        REFUSE: "拒绝",
        CANCEL: "取消"
      };
      const code = this.statementData.status;
      return statusObj[code];
    }
  },
  methods: {
    goToDetails(id) {
      this.$router.push({
        path: "/main/management-contract-details",
        query: { id }
      });
    },
    onSubmit() {
      this.getList();
    },
    openRefuseDialog(row) {
      this.statementData = new StatementData(row, "REFUSE");
      this.refuseAndCancelDialogVisible = true;
    },
    openCancelDialog(row) {
      this.statementData = new StatementData(row, "CANCEL");
      this.refuseAndCancelDialogVisible = true;
    },
    openServedDialog(row) {
      this.statementData = new StatementData(row, "COMPLETE");
      this.servedDialogVisible = true;
    },
    onFormSubmit() {
      if (!this.statementData.reason) {
        this.$message.warning(`请输入${this.refuseAndCancelDialogTitle}原因`);
        return false;
      }
      this.refuseAndCancelDialogVisible = false;
      this.handleServe(this.statementData);
    },
    openAgreeDialog(row) {
      this.row = row;
      const apmObj = {
        AM: "09:00",
        PM: "14:00"
      };
      row.appointTime =
        timeFormat(row.expectedDate, "%Y-%m-%d") +
        " " +
        apmObj[row.expectedAmpm];
      this.statementData = new StatementData(row, "WAITUSE");
      this.agreeDialogVisible = true;
    },
    onAgree() {
      this.agreeDialogVisible = false;
      this.handleServe(this.statementData);
    },
    onServed() {
      this.servedDialogVisible = false;
      this.handleServe(this.statementData);
    },
    handleServe({ serveAppointId, status, appointTime, reason, message }) {
      axiosUtil(
        {
          serveAppointId,
          status,
          appointTime,
          reason,
          service: "smarthos.contract.serve.appoint.status.update",
          token: localStorage.getItem("token")
        },
        ({ code, list, page, msg }) => {
          if (code === "0") {
            this.$message.success(`${message}成功`);
            this.getList();
          } else {
            this.$message.error(msg);
          }
        }
      );
    },
    onCurrentChange(pageNum) {
      this.page.pageNum = pageNum;
      this.getList();
    },
    getList() {
      this.loading = true;
      axiosUtil(
        {
          status: this.checkedStatus,
          service: "smarthos.contract.serve.appoint.list",
          token: localStorage.getItem("token"),
          ...this.page,
          ...this.filtersForm
        },
        ({ code, list, page, msg }) => {
          if (code === "0") {
            this.loading = false;
            this.list = list;
            this.page = page;
          } else {
            this.$message.error(msg);
          }
        }
      );
    },
    formatAddress(row, column, columnValue) {
      return row.serveWay === "DOOR"
        ? row.address
        : row.serveWay === "HOSPITAL"
        ? row.hosAddress
        : "";
    },
    formatterAppointTime(row, column, columnValue) {
      return timeFormat(row.appointTime, "%Y年%m月%d日 %H:%M");
    },
    formatterServeDate(row, column, columnValue) {
      const expectedDate = timeFormat(row.expectedDate, "%Y/%m/%d");
      const apm = {
        AM: "上午",
        PM: "下午"
      };
      return expectedDate + " " + apm[row.expectedAmpm];
    },
    formatterCreateTime(row, column, createTime) {
      return timeFormat(createTime, "%Y-%m-%d %H:%M:%S");
    },
    formatterServeUsage(row, colum, columnValue) {
      if (row.serveTotalNumber === -1) row.serveTotalNumber = "不限";
      return `${row.serveUseNumber}/${row.serveTotalNumber}`;
    },
    formatterServeWay(row, column, code) {
      const serveWays = {
        ONLINE: "在线",
        DOOR: "上门服务",
        HOSPITAL: "到院服务"
      };
      return serveWays[code];
    }
  }
};
</script>

<style lang="scss">
.management-service-reservation {
  .el-table {
    margin-top: 15px;
  }
  .pagination-wrapper {
    padding: 20px 0;
  }
  .red-color {
    color: #f56c6c;
  }
  .agree-dialog {
    .el-row {
      margin-bottom: 10px;
    }
  }
  .el-dialog__footer {
    text-align: center;
  }
  .served-dialog__desc {
    text-align: center;
    margin-top: 20px;
    font-size: 18px;
    font-weight: 600px;
  }
  .el-table .cell {
    max-height: 69px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
}
</style>
